/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Usermanagement_Help_Understandingroles2Inputs */

const en_usermanagement_help_understandingroles2 = /** @type {(inputs: Usermanagement_Help_Understandingroles2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Understanding User Roles and Permissions`)
};

/**
* | output |
* | --- |
* | "Understanding User Roles and Permissions" |
*
* @param {Usermanagement_Help_Understandingroles2Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const usermanagement_help_understandingroles2 = /** @type {((inputs?: Usermanagement_Help_Understandingroles2Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Usermanagement_Help_Understandingroles2Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_usermanagement_help_understandingroles2(inputs)
});
export { usermanagement_help_understandingroles2 as "userManagement_help_understandingRoles" }